module.exports = __webpack_public_path__ + "img/b1 (2).8a6cc565.png";